<template>
  <v-sheet color="primary_light_1" tile>
    <v-container>
      <v-row class="white--text">
        <v-col cols="6" class="d-flex flex-column align-center">
          <div class="mb-4">
            <p class="title">抬頭：台灣血管外科學會</p>
            <p class="title">統編：48682216</p>
          </div>
          <div class="mb-4">
            <p class="title">中華郵政劃撥</p>
            <p class="title">帳號：19944001</p>
            <p class="title">戶名：台灣血管外科學會</p>
          </div>
          <div>
            <p class="title">銀行電滙</p>
            <p class="title">合作金庫代號：006</p>
            <p class="title">立帳銀行：長庚分行</p>
            <p class="title">帳號：3638-717-000159</p>
            <p class="title">戶名：台灣血管外科學會</p>
          </div>
        </v-col>

        <v-col cols="6" class="d-flex flex-column align-center">
          <div>
            <div class="mb-4">
              <p class="title">Taiwan Society for Vascular Surgery (TSVS)</p>
            </div>
            <div class="d-flex">
              <p class="title mr-4">OFFICE HOUR：</p>
              <p class="title">9 AM - 5 PM</p>
            </div>
            <div class="d-flex">
              <p class="title mr-4">Addrss：</p>
              <p class="title">
                95 Wen Chang Rd, Shih Lin District, Taipei, TAIWAN 11101 台北市士林區文昌路 95 號 新光 B2 周邊血管檢查室
                11101
              </p>
            </div>
            <div class="d-flex">
              <p class="title mr-4">Telephone：</p>
              <p class="title">+886-2-28332211#2834</p>
            </div>
            <div class="d-flex">
              <p class="title mr-4">Cellphone：</p>
              <p class="title">+886-966-877-552</p>
            </div>
            <div class="d-flex">
              <p class="title mr-4">E-mail：</p>
              <p class="title">4tsvs@tsvs.org</p>
            </div>
            <div class="d-flex">
              <p class="title mr-4">Website：</p>
              <p class="title">www.tsvs.org</p>
            </div>
            <div class="d-flex">
              <p class="title mr-4">聯絡人：</p>
              <p class="title">許心慈</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: "Information"
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  font-weight: 300 !important;
}
</style>
